import React, {FunctionComponent, useContext, useEffect, useRef, useState} from 'react';
import MapContext from '../map/MapContext';
import {Fill, Icon, Stroke, Style} from 'ol/style';
import Select from 'ol/interaction/Select';
import {click} from 'ol/events/condition';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import geoSettings from '../../../config/geoSettings';
import {parseStyle} from '../../../functions/functionsOpenlayer';
import {setSelectedFeatures} from "../../../redux/slices/GeomonitoringSlice";

type geocodingProps = {
}

const SelectInteraction: FunctionComponent<geocodingProps> = (props) => {
    // @ts-ignore
    const {map} = useContext(MapContext);
    const dispatch = useAppDispatch();
    const selection=useAppSelector((state:any)=>state.configLayer.layerData.selection);
    const styleArray=useAppSelector((state:any)=>state.configLayer.layerData.styleArray);
    const refKennz=useRef(selection);
    const clearSelectionValue = useAppSelector((state: any) => state.configLayer.layerData.clearSelection);

    const unSelected = new Style({
        fill: new Fill({
            color: 'rgba(255,255,255,0)',
        }),
        stroke: new Stroke({
            color: 'rgba(54,52,52,0.2)',
            width: 0.5,
        }),
    });

    const selectStyle = new Style({
        fill: new Fill({
            color: '#39dada',
        }),
        stroke: new Stroke({
            color: 'rgba(10,10,10,0.7)',
            width: 2,
        }),
    });

    // select interaction working on "click"
    const select = new Select({
        condition: click,
        style: selectStyle,
    });


    const setHighlightSelectedFeatures=(features:any)=>{
        const selectedFeatures: any[] = [];
        features.forEach((f:any)=>{
            const fKennz=f.get('view_flstk');
            //  if()
            if (refKennz.current.includes(fKennz)) {
                f.setStyle(selectStyle);
                selectedFeatures.push(f);
            } else {
                f.setStyle(undefined);
            }

        });
        if(selectedFeatures.length>0)
        setView(selectedFeatures);
    };

    const setLayerStyle=(layer:any)=>{
        if (!styleArray || Object.keys(styleArray).length  === 0) {
            if (refKennz.current.length>0) {
                layer.setStyle(unSelected);
            }
            return;
        }

        if (refKennz.current&&refKennz.current.length>0) {
            layer.setStyle(unSelected);
        } else {
            const styleId=geoSettings.parcelLayer.toLowerCase();

            parseStyle(styleArray[styleId][styleId].default, layer);
        }
    };

    const setView=(features:any)=>{
        if (features) {
            const mapView=map.getView();
            if (features.length===1) {
                const extent = features[0].getGeometry().getExtent();
                mapView.fit(extent);
            } else  if (features.length>1) {
                const coordinates = features[0].getGeometry().getCoordinates();
                mapView.setCenter(coordinates[0][0][0]);
                mapView.setZoom(15);
            }  
        }

    };

    const getParcelLayer=()=>{
        const layers= map.getLayers().getArray();
        let parcelLayer:any=null;
        layers.forEach((layer:any)=>{
            if (layer.get('id')===geoSettings.parcelLayer.toLowerCase()) {
                parcelLayer=layer;
            }
        });
        return parcelLayer;
    };

    const pendingInterval=()=>{

        const pInterval=setInterval(function() {const parcelLayer=getParcelLayer();if (parcelLayer!==null) {
            clearInterval(pInterval);
            getFeaturesToSelect();
        }}, 2000 );
    };

    const getFeaturesToSelect=()=>{
        if (!map || Object.keys(map).length === 0) return;

        const parcelLayer=getParcelLayer();

        if (parcelLayer!==null) {
            setLayerStyle(parcelLayer);
            const features=parcelLayer.getSource().getFeatures();
            setHighlightSelectedFeatures(features);
        } else {
            if (refKennz.current.length>0) {
                pendingInterval();
            }
        }
 
    };
    
    useEffect(()=>{
        if (!map || Object.keys(map).length === 0) return;
        map.addInteraction(select);
    },[map]);

    useEffect(()=>{
        refKennz.current=selection;
        getFeaturesToSelect();
    },[selection]);


    useEffect(() => {
        setHighlightSelectedFeatures([]);
        // @ts-ignore
        dispatch(setSelectedFeatures([]));
    }, [clearSelectionValue]);

    return (
        // @ts-ignore
        <div>
        </div>);
};

export default SelectInteraction;
